import script from "./TestPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./TestPage.vue?vue&type=script&setup=true&lang=ts"

import "./TestPage.vue?vue&type=style&index=0&id=87152c6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87152c6a"]])

export default __exports__